import React, {
  FormEvent, ReactElement, useEffect, useState,
} from 'react';
import { useNavigate, useParams } from 'react-router';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import { useClient, useClientStatusContext } from '../../../../context/ClientStatusContext';
import routes from '../../../../routing/routes';
import { updateTerminPoznamka } from '../../../../client/termin/terminPoznamkaUpdateClient';
import PoznamkaUpdateForm from './component/PoznamkaUpdateForm';
import { technickePricinyErrorStatus } from '../../../../constants/ErrorConstant';

interface Props {
  initialPoznamka?: string;
}

const PoznamkaUpdate = ({ initialPoznamka }: Props): ReactElement => {
  const [poznamka, setPoznamka] = useState(initialPoznamka || '');
  const { tezaurusUuid, terminUuid } = useParams<{ tezaurusUuid: string, terminUuid: string }>();

  const {
    wrapClient: terminPoznamkaUpdateClient,
    status: updateTerminStatus,
  } = useClient(updateTerminPoznamka);

  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const { handleStatus } = useClientStatusContext();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    await terminPoznamkaUpdateClient(terminUuid, poznamka);
    navigate(routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(() => {
    if (updateTerminStatus?.responseCode === 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [updateTerminStatus, handleStatus]);

  return (
    <PoznamkaUpdateForm
      poznamka={poznamka}
      setPoznamka={setPoznamka}
      onSubmit={handleSubmit}
      loading={updateTerminStatus.loading}
    />
  );
};

export default PoznamkaUpdate;
